(()=>{function bolesNormalizeSize(raw){const value=String(raw).trim().toUpperCase().replace(/\s+/g,' ');const aliases={'EXTRA EXTRA SMALL':'XXS','X-SMALL':'XS','X SMALL':'XS','EXTRA SMALL':'XS','SMALL':'S','MEDIUM':'M','LARGE':'L','X-LARGE':'XL','X/LARGE':'XL','X LARGE':'XL','EXTRA LARGE':'XL','XLARGE':'XL','XX-LARGE':'XXL','XX LARGE':'XXL','XXLARGE':'XXL','2XL':'XXL','EXTRA EXTRA LARGE':'XXL','XXXL':'3XL','XXX-LARGE':'3XL','3X LARGE':'3XL','OS':'One size','ONE SIZE':'One size','ONESIZE':'One size'};if(aliases[value])return aliases[value];if(/^SIZE \d/.test(value))return value.replace(/^SIZE /,'');if(value.includes('/'))return value.split('/').map(part=>aliases[part.trim()]||part.trim()).join('/');return value;}
  function update(picker){
    const form=picker.closest('form');
    if(!form)return;
    const index=Number(picker.dataset.sizeIndex);
    const select=picker.querySelector('select.single-option-selector');
    const variants=JSON.parse(picker.querySelector('.boles-size-variants').textContent);
    const selects=Array.from(form.querySelectorAll('select.single-option-selector'));
    let unavailable=false;
    picker.querySelectorAll('.boles-size-button').forEach(button=>{
      const value=button.dataset.sizeValue;
      button.textContent=bolesNormalizeSize(value);
      const available=variants.some(variant=>variant.available && variant.options[index]===value && selects.every(other=>{
        const otherIndex=Number(other.dataset.index.replace('option',''))-1;
        return otherIndex===index || !other.value || variant.options[otherIndex]===other.value;
      }));
      button.disabled=!available;
      button.setAttribute('aria-pressed',String(select.value===value));
      button.setAttribute('aria-label',bolesNormalizeSize(value)+(available?'':' — out of stock'));
      unavailable=unavailable||!available;
    });
    picker.querySelector('.boles-size-selected').textContent=bolesNormalizeSize(select.value);
    picker.querySelector('.boles-size-stock-note').hidden=!unavailable;
  }
  function refresh(scope=document){scope.querySelectorAll('.boles-size-picker').forEach(update);}
  document.addEventListener('click',event=>{
    const button=event.target.closest('.boles-size-button');
    if(!button||button.disabled)return;
    const picker=button.closest('.boles-size-picker');
    const select=picker.querySelector('select.single-option-selector');
    select.value=button.dataset.sizeValue;
    if(window.jQuery)window.jQuery(select).trigger('change');
    else select.dispatchEvent(new Event('change',{bubbles:true}));
    refresh(picker.closest('form'));
  });
  document.addEventListener('change',event=>{if(event.target.matches('.single-option-selector'))refresh(event.target.closest('form'));});
  if(window.jQuery)window.jQuery(document).on('change.bolesSizes','.single-option-selector',function(){refresh(this.closest('form'));});
  refresh();
  new MutationObserver(records=>{
    if(records.some(record=>Array.from(record.addedNodes).some(node=>node.nodeType===1 && (node.matches('.boles-size-picker')||node.querySelector('.boles-size-picker')))))refresh();
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
